import React, {Fragment,Component,useState,useEffect} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {codeStatusToCh} from '../../util';
import axios from 'axios';
import {Header,Divider,Message, Form, Table, Tab} from 'semantic-ui-react';
import {Modal,Dimmer, Loader, Grid, Segment, Item, Image, Popup, Button, Icon, Card} from 'semantic-ui-react';
import {fetchUserStatus} from '../actions';
import {withTranslation} from 'react-i18next';
import Panel from '../../components/Panel';

const renderSystemCodeList = (data, index) => ({
  key: data.id,
  disabled: data.status !== 'valid',
  cells: [
    {content: data.code, key: 'code'},
    {content: data.days, key: 'days'},
    {content: codeStatusToCh[data.status] || data.status, key: 'status'},
  ],
});

const SystemCodeList = ({list}) => (
  <div>
    <Table
      attached
      unstackable
      color='orange'
      headerRow={{cells: ['兑换码', '可兑换天数', '状态']}}
      renderBodyRow={renderSystemCodeList}
      tableData={list}
    />
  </div>
);

const Codes = (props)=>{

const [list,setList]       = useState([]);
const [message,setMessage] = useState(false);
let   confirms             = 0;

const fetchList= async () => {
  return await axios.get('/user/codes').then((res) => {
    const {code, data} = res.data;
    if (code === 0) {
      setList(data.system)
    }
  })
}

useEffect(() => {
  fetchList()
  return ()=>{
  }
}, []);

const submit = async (days)=>{

  if(confirms == 0){
    const sure = window.confirm("是否扣除" + days + "天 ？")
    if(!sure){
      return;
    }else{
      confirms = 1
    }
  }

  const ret = await axios.post("/user/redeem/generates",{days})
  if(ret.data && ret.data.data == false){
    if(ret.data.code == 3){
      setMessage("Fail to generate, limited");
    }
    if(ret.data.code == 2){
      setMessage("Fail to generate, too fast");
    }
  }else{
    setMessage("1 Code Generated");
  }
  fetchList()
}

return (
  <Fragment>
    <Segment>
    <Header
      as='h2'
      style={{marginTop:"2px"}}
      content='生成礼品码'
      subheader='Make Basic Plan Giftcards'
      dividing
    />

  <p>Pro 用户可以将自己的会员天数扣除30天, 并生成兑换码给新用户使用, 用户可以兑换为30天 <b>Basic Plan</b> 会员。</p>
  <Message
    error
    header='特别重要:此操作不可撤销'
    list={[
      '此操作将会您的剩余天数 扣除 一部分并转为礼品兑换码',
      '扣除天数是不可逆操作'
    ]}
  />
  <Divider/>
  <div>
    <p>将自己的 Pro 会员天数 扣除 后，换成兑换码.</p>
    <Button primary onClick={()=>{submit(30)}} >Make 30 days code</Button>
  </div>
  <br/>
  <br/>
  <div>
    {message?<Message info >{message}</Message>:null}
  </div>

  <Divider/>
  <SystemCodeList list={list}/>
 </Segment>
</Fragment>
  )

}

export default Codes;
